import { render, staticRenderFns } from "./DxAdditionalInfo.vue?vue&type=template&id=4893b1f0&"
import script from "./DxAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./DxAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports